// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <v-toolbar-title>API Key</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="newItem" dark color="success" @click="saveItem">Save</v-btn>
        <v-btn v-if="canModify && !newItem" dark color="red" @click="showDeleteDialog = true">Delete</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="formValid" ref="form">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="Name"
                v-model="item.name"
                :rules="[ruleRequired]"
                :disabled="!newItem"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Token"
                v-model="item.token"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-autocomplete
                v-bind:items="roles"
                v-model="item.roles"
                item-text="name"
                item-value="id"
                multiple
                chips
                label="Roles"
                :rules="[ruleOnePlus]"
                :disabled="!newItem"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6>
              <v-autocomplete
                v-bind:items="sites"
                v-model="item.securityCtx.sites"
                item-text="name"
                item-value="_id"
                multiple
                chips
                label="Sites"
                required
                :rules="[ruleOnePlus]"
                :disabled="!newItem"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showDeleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Confirm Delete</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete this API Key?  <b>This action cannot be undone.</b></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn text color="red" @click="deleteItem()">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ApiRequests from '@/api/ApiRequests'
  import {PERMISSIONS, WILDCARDBSON} from '@sdgsystems/vue-common/components/constants'
  import {checkPermission} from '@sdgsystems/vue-common/components/user'
  import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'
  import Rules from '@sdgsystems/vue-common/components/rules'

  export default {
    components: {
      ErrorSnackbar
    },

    data () {
      return {
        errorText: '',
        formValid: null,
        roles: [],
        showDeleteDialog: false,
        sites: [],
        item: {
          securityCtx: {
            sites: []
          }
        }
      }
    },

    created () {
      this.getItem()
      this.getRoles()
      ApiRequests.getSites().then(r => {
        this.sites = r.data
        this.sites.unshift({name: 'All Sites', _id: WILDCARDBSON})
      })
    },

    computed: {
      ...mapGetters({
        activeAccessRules: 'accessRules'
      }),

      canModify: function () {
        return checkPermission(this.activeAccessRules, 'apikeys', PERMISSIONS.MODIFY)
      },

      newItem: function () {
        return (this.$route.params.id === 'new')
      }
    },

    methods: {
      deleteItem: function () {
        ApiRequests.deleteApiKey(this.item._id).then(r => {
          this.exit()
        }).catch(e => {
          this.errorText = e.response.statusText + ': ' + e.response.data
        })
      },

      getItem: function () {
        if (this.newItem) {
        } else {
          ApiRequests.getApiKey(this.$route.params.id).then(r => {
            this.item = r.data
          }).catch(e => {
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        }
      },

      getRoles: function () {
        ApiRequests.getRoles().then((response) => {
          this.roles = response.data
          var index = this.roles.findIndex((el) => el.name === 'Super Admin')
          if (index > -1) {
            this.roles.splice(index, 1)
          }
        })
      },

      saveItem: function () {
        if (this.$refs.form.validate()) {
          ApiRequests.postApiKey(this.item).then(response => {
            this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        } else {
          this.errorText = 'Please fill out all required fields'
        }
      },

      ruleOnePlus: function (x) {
        if (this.ruleRequired(x)) {
          if (x.length > 0) {
            return true
          } else {
            return 'You must select at least one item'
          }
        }
        return this.ruleRequired(x)
      },

      ruleRequired: function (x) {
        return Rules.required(x)
      },

      exit: function () {
        this.$router.push({name: 'apikeys'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ApiKeyEdit.vue